module.exports = __webpack_public_path__ + "img/logo-mintt.d5091293.png";